import { z } from 'zod';

/**
 * Schema de validación del formulario de instructor (react-hook-form + zod).
 * Mensajes en español, siguiendo la convención del resto de schemas del repo.
 *
 * El tipo de instructor no se valida aquí: todos son externos y se fija en el
 * envío. El correo y el teléfono son opcionales; cuando traen valor, sí se
 * valida su formato.
 */
export const instructorFormSchema = z.object({
  name: z.string().trim().min(1, 'El nombre es obligatorio'),
  email: z
    .string()
    .trim()
    .refine(value => value === '' || z.string().email().safeParse(value).success, 'Correo electrónico inválido'),
  phone: z
    .string()
    .trim()
    .refine(
      value => value === '' || /^[\d\s()+-]+$/.test(value),
      'El teléfono solo admite dígitos y los signos + - ( )'
    )
    .refine(value => value === '' || value.replace(/\D/g, '').length >= 8, 'El teléfono debe tener al menos 8 dígitos'),
  organization: z.string().trim(),
  status: z.enum(['active', 'inactive']),
});

export type InstructorFormValues = z.infer<typeof instructorFormSchema>;
